import { GlobalLayout } from "@newsela/angelou";

import Popout from "@/components/Popout";

const { unifiedNavsMediaQuery } = GlobalLayout;

export const editContainerCss = {
  textAlign: "right",
};

export const editIconCss = {
  height: "24px",
  width: "24px",
};

export const editStepCss = {
  width: "200px",
};

export const editMenuCss = {
  margin: 0,
  padding: 0,
  "> li": {
    listStyle: "none",
    margin: 0,
    padding: 0,
  },
};

export const editStepPopoutCss = {
  zIndex: 1,
};

export const editStepPopoutRowCss = [
  Popout.rowCss,
  Popout.spaciousRowCss,
  { [unifiedNavsMediaQuery]: Popout.denseRowCss },
];
